module.exports = __webpack_public_path__ + "assets/img/swiper-img1-d81e67e6.png";